// extracted by mini-css-extract-plugin
module.exports = {"header":"dWmD","chatTitle":"tZhU","title":"Fovq","leftAddon":"hLr-","rightAddon":"mxMM"};